/*
 * Store-truth stock check for AI search results. The search index's
 * `available` flag can be stale, so each own-store product is confirmed
 * against the live store: /products/<handle>.js answers 404 for a product that
 * no longer exists (discontinued or unpublished) and `available: false` for one
 * that is sold out. Both are dropped from products, suggestions and bestMatch.
 * Products from another store (crossStore) can't be checked here and keep the
 * index's answer. Results are cached per handle for the page's life.
 * Fail-soft: a network error or non-JSON answer keeps the product (fail open),
 * and any unexpected error returns the input unchanged.
 */
(function () {
  var cache = {};

  function check(handle, fetchFn) {
    if (!handle) return Promise.resolve(false);
    if (cache[handle]) return cache[handle];
    cache[handle] = fetchFn('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (r.status === 404) return false;
        if (!r.ok) return true;
        return r.json().then(function (p) { return !p || p.available !== false; }, function () { return true; });
      })
      .catch(function () { return true; });
    return cache[handle];
  }

  function keep(list, fetchFn) {
    return Promise.all((list || []).map(function (p) {
      return check(p && p.slug, fetchFn).then(function (ok) { return ok ? p : null; });
    })).then(function (l) { return l.filter(Boolean); });
  }

  function verify(data, fetchFn) {
    fetchFn = fetchFn || (typeof fetch !== 'undefined' ? fetch.bind(window) : null);
    if (!data || !fetchFn) return Promise.resolve(data);
    return Promise.all([keep(data.products, fetchFn), keep(data.suggestions, fetchFn)]).then(function (r) {
      var out = Object.assign({}, data);
      if (data.products) out.products = r[0];
      if (data.suggestions) out.suggestions = r[1];
      if (out.bestMatch && !(out.products || []).some(function (p) { return p.slug === out.bestMatch; })) out.bestMatch = null;
      return out;
    }).catch(function () { return data; });
  }

  var api = { verify: verify, _reset: function () { cache = {}; } };
  if (typeof window !== 'undefined') window.AISearchStock = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
